module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/aditional-proposal-approver/component/aditional-proposal-approver/aditional-proposal-approver.component.scss
// module id = ./src/app/aditional-proposal-approver/component/aditional-proposal-approver/aditional-proposal-approver.component.scss
// module chunks = main